export enum EventCategory {
  ERROR = 'Error',
  LOGIN = 'Login'
}

export enum EventGTM {
  ERROR = 'Error',
  LOGIN = 'Login'
}
